/**
 * Versão do SDK JS / Graph API da Meta — fallback do frontend do HUB (02/10/2026).
 *
 * O valor real vem do backend (apiVersion da config Meta e da sessão de conexão), resolvido no
 * ponto único backend/src/config/metaGraph.ts (padrão v25.0, sobreponível por FACEBOOK_API_VERSION).
 * Este padrão só vale se o backend não mandar nada; mantenha igual ao do backend.
 */
export const META_GRAPH_VERSION_PADRAO = "v25.0";
